export default (value: string) => parseInt(value.replace(/\s/g, ''));
